import {ManageMediaModal} from "./ManageMediaModal/ManageMediaModal";
import Swal from "sweetalert2";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";
import {NotesDisplay} from "../../people/notes/NotesDisplay";
import {PersonNotesModal} from "../../people/notes/PersonNotesModal";
import {randomUniqueClassName} from "../../../helpers/inputs/random/strings";
import {waitUntil} from "../../../helpers/waitUntil";
import {initShirtSizeInput} from "../../../helpers/inputs/shirtSizeSelect/shirtSizeSelect";

/**
 * Shared by cast and crew index views
 */
function initProductionAuditionRequestsShow() {

	const manageMediaButton = document.querySelector('.manage-photos-button');
	if (manageMediaButton) {
		manageMediaButton.addEventListener('click', () => {
			displayManageMediaModal()
		});
	}

	const setStipendButton = document.querySelector('.set-stipend-button');
	if (setStipendButton) {
		setStipendButton.addEventListener('click', () => {
			handleSetStipendRequest(setStipendButton.dataset.route);
		})
	}


	const setShirtSizeButton = document.querySelector('.set-shirt-size-button');
	if (setShirtSizeButton) {
		setShirtSizeButton.addEventListener('click', () => {
			handleSetShirtSizeRequest(setShirtSizeButton.dataset.route, setShirtSizeButton.dataset.value);
		});
	}

	const setPaperworkFlagButton = document.querySelector('.set-paperwork-flag-button');
	if (setPaperworkFlagButton) {
		setPaperworkFlagButton.addEventListener('click', () => {
			handleSetPaperworkFlagRequest(setPaperworkFlagButton.dataset.route);
		})
	}

	const setProcessedByAccountingFlagButton = document.querySelector('.set-processed-by-accounting-flag-button');
	if (setProcessedByAccountingFlagButton) {
		setProcessedByAccountingFlagButton.addEventListener('click', () => {
			handleSetProcessedByAccountingFlagRequest(setProcessedByAccountingFlagButton.dataset.route);
		})
	}

	const setRemoveFromProductionButton = document.querySelector('.remove-from-production-button');
	if (setRemoveFromProductionButton) {
		setRemoveFromProductionButton.addEventListener('click', () => {
			handleRemoveFromProductionRequest(setRemoveFromProductionButton.dataset.route);
		})
	}

	const setRestoreFromProductionButton = document.querySelector('.restore-to-production-button');
	if (setRestoreFromProductionButton) {
		setRestoreFromProductionButton.addEventListener('click', () => {
			handleRestoreFromProductionRequest(setRestoreFromProductionButton.dataset.route);
		})
	}

	// Init notes display
	const notesDisplay = new NotesDisplay(document.querySelector('.person-notes-display-component'));
	const addNoteButton = document.querySelector('.add-note-button');

	// noinspection DuplicatedCode
	if (addNoteButton) {
		addNoteButton.addEventListener('click', () => {
			handleNotesModalRequest(addNoteButton.dataset.route)
		})
	}

	const banButton = document.querySelector('.ban-button');

	if (banButton) {
		banButton.addEventListener('click', () => {
			ban(banButton.dataset.route);
		})
	}

	const unbanButton = document.querySelector('.unban-button');

	if (unbanButton) {
		unbanButton.addEventListener('click', () => {
			unban(unbanButton.dataset.route);
		})
	}


	/** Methods */

	function displayManageMediaModal() {
		const modal = new ManageMediaModal({
			modalContainer: document.querySelector('.manage-media-modal'),
		})

		modal.display(true);
	}

	function handleSetStipendRequest(route) {
		Swal.fire({
			title: 'Set Stipend',
			input: "number",
			showCancelButton: true,
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route, {
					stipend: result.value
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	function handleSetShirtSizeRequest(route, initialValue) {
		const swalInputClass = randomUniqueClassName('swal_shirt_size');

		Swal.fire({
			title: 'Set Shirt Size',
			showCancelButton: true,
			html: `<input type="text" autocomplete="off" class="form-control ${swalInputClass}" value="${initialValue}">`
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route, {
					shirt_size: document.querySelector(`.${swalInputClass}`).value
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})

		// Initialize shirt size input
		waitUntil(() => document.querySelector(`.${swalInputClass}`))
			.then(() => {
				initShirtSizeInput(document.querySelector(`.${swalInputClass}`))
			})
	}

	function handleSetPaperworkFlagRequest(route) {
		loading();

		Axios.post(route)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handleSetProcessedByAccountingFlagRequest(route) {
		loading();

		Axios.post(route)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handleRemoveFromProductionRequest(route) {
		swalConfirm({
			title: 'Remove Crew Member From Production?',
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	function handleRestoreFromProductionRequest(route) {
		swalConfirm({
			title: 'Restore Crew Member To Production?',
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	// noinspection DuplicatedCode
	function handleNotesModalRequest(route) {
		new PersonNotesModal(route, {
			onSuccess: () => {
				// If modal made any changes, refresh notes display
				notesDisplay.update(false);
			}
		});
	}

	function ban(route) {
		Swal.fire({
			icon: "warning",
			title: 'Ban staff member?',
			inputLabel: 'Ban Reason',
			input: 'textarea',
			showCancelButton: true,
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route, {
					reason: result.value,
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	function unban(route) {
		Swal.fire({
			icon: "warning",
			title: 'Unban staff member?',
			showCancelButton: true,
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				Axios.post(route, {
					reason: result.value,
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}
}

export {
	initProductionAuditionRequestsShow
}
